import {HANDLE_OPEN_NAV_ITEM, SET_SELECTED_ITEM} from "../actions/setNavLink";

export const initialState = {
    navLink: "",
    navItem: "accueil"
};

const navLink = (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_SELECTED_ITEM : {
            return {
                ...state,
                navLink: action.string
            };
        }
        case HANDLE_OPEN_NAV_ITEM: {
            return {
                ...state,
                navItem: action.string,
            };
        }
        default :
            return state;
    }
};

export default navLink;